var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkLogoCropped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "626.7994310099573 292.864 67.59601706970128 77.824",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    style: {
      maxHeight: 500
    },
    width: 67.59601706970128,
    height: 77.824,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #2a5f9e;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #ed4c5c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M653.72,349.45v-9.21l-6.88,5.07c1.97,1.81,4.3,3.23,6.88,4.14Z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M667.05,349.45c2.58-.91,4.92-2.34,6.89-4.16l-6.89-5.07v9.23Z",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M641.53,337.26c.23.65.49,1.29.79,1.91l2.59-1.91h-3.38Z",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M675.86,337.26l2.6,1.91c.29-.62.56-1.26.79-1.91h-3.38Z",
    className: "st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M654.69,334.59h-13.9c.18.91.44,1.8.74,2.67h3.38l-2.59,1.91c.52,1.1,1.15,2.15,1.86,3.13l6.88-5.04h2.67v1.37h0s-7.8,5.76-7.8,5.76c.3.32.61.62.93.92l6.88-5.07v9.21c.86.31,1.75.56,2.67.74v-13.52h0v-2.08h-1.7Z",
    className: "st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M679.98,334.59h-15.6v15.6c.91-.18,1.8-.44,2.67-.74v-9.23s6.89,5.07,6.89,5.07c.92-.85,1.76-1.78,2.51-2.79l-7.1-5.24h4.51l4.04,2.98h0c.19-.35.38-.71.55-1.07l-2.6-1.91h3.38c.31-.86.56-1.75.74-2.67Z",
    className: "st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M644.2,342.33c.52.72,1.09,1.4,1.7,2.04,0,0,.01.01.02.02l7.8-5.75h0v-1.38h-2.64l-6.88,5.07Z",
    className: "st2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M669.36,337.26l7.1,5.23c.25-.33.48-.68.71-1.02.03-.05.07-.11.1-.16.22-.35.43-.7.64-1.07l-4.04-2.98h-4.5Z",
    className: "st2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M667.05,311.73v9.21l6.88-5.07c-1.97-1.81-4.3-3.23-6.88-4.14Z",
    className: "st0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M653.72,311.73c-2.58.91-4.92,2.34-6.89,4.16l6.89,5.07v-9.23Z",
    className: "st0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M679.24,323.92c-.23-.65-.49-1.29-.79-1.91l-2.59,1.91h3.38Z",
    className: "st0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M644.91,323.92l-2.6-1.91c-.29.62-.56,1.26-.79,1.91h3.38Z",
    className: "st0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M666.08,326.59h13.9c-.19-.91-.44-1.8-.74-2.67h-3.38l2.59-1.91c-.53-1.1-1.15-2.15-1.86-3.13l-6.88,5.04h-2.66v-1.37h0s7.8-5.76,7.8-5.76c-.3-.32-.61-.62-.93-.92l-6.87,5.07v-9.21c-.86-.31-1.75-.56-2.67-.74v13.52h0v2.08h1.69Z",
    className: "st1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M640.79,326.59h15.6v-15.6c-.91.18-1.8.44-2.67.74v9.23s-6.89-5.07-6.89-5.07c-.92.85-1.76,1.78-2.51,2.79l7.1,5.24h-4.51s-4.04-2.98-4.04-2.98h0c-.19.35-.38.71-.55,1.07l2.6,1.91h-3.38c-.31.86-.56,1.75-.74,2.67Z",
    className: "st1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M676.57,318.85c-.52-.72-1.09-1.4-1.7-2.04,0,0-.01-.01-.02-.02l-7.8,5.75h0v1.38h2.64l6.89-5.07Z",
    className: "st2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M651.41,323.92l-7.1-5.23c-.25.33-.48.68-.71,1.03-.03.05-.07.11-.1.16-.22.35-.43.7-.64,1.07l4.04,2.98h4.5Z",
    className: "st2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M679.98,326.59h-15.6v-2.07h0v-13.52c-1.29-.26-2.63-.4-4-.4s-2.71.14-4,.4v15.6h-15.6c-.26,1.29-.4,2.63-.4,4s.14,2.71.4,4h15.6v2.07h0v13.53c1.29.26,2.63.4,4,.4s2.71-.14,4-.4v-15.6h15.6c.26-1.29.4-2.63.4-4s-.14-2.71-.4-4Z",
    className: "st2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkLogoCropped);
export default __webpack_public_path__ + "static/media/uk_logo-cropped.784c7f6cd28b74684493f6bfdebaa22a.svg";
export { ForwardRef as ReactComponent };